import { motion } from "framer-motion";
import { Waves, Target, Users } from "lucide-react";

export default function ChiSiamo() {
  return (
    <section id="chi-siamo" data-testid="section-chi-siamo" className="relative py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.3em] text-purple-300/80 mb-4">02 · Chi siamo</div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white leading-[0.95]">
              Uniamo il <span className="text-gradient">digitale</span> al mondo reale.
            </h2>
            <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed">
              Siamo <strong className="text-white">Social Whale</strong>, una realtà di comunicazione
              giovane e dinamica nata per unire il mondo digitale all'esperienza fisica all'interno
              del punto vendita. Prima di scegliere un servizio, tutti cercano online una conferma
              della qualità che troveranno offline: noi rendiamo quella conferma inevitabile.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-5">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7 }}
              className="glass gradient-border rounded-3xl p-8 sm:col-span-2"
              data-testid="about-mission"
            >
              <div className="flex items-center gap-3 text-purple-300 mb-3">
                <Target size={20} strokeWidth={1.7} />
                <span className="text-xs uppercase tracking-[0.25em]">La nostra missione</span>
              </div>
              <p className="text-slate-100 text-lg md:text-xl leading-snug font-display">
                Supportare imprese e commercianti nel raccontarsi in modo autentico, gestendo la
                loro presenza in ogni dettaglio per trasformare ogni interazione online in un
                incontro reale.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.1 }}
              className="glass gradient-border rounded-3xl p-8"
              data-testid="about-vision"
            >
              <div className="flex items-center gap-3 text-blue-300 mb-3">
                <Waves size={20} strokeWidth={1.7} />
                <span className="text-xs uppercase tracking-[0.25em]">Visione</span>
              </div>
              <p className="text-slate-200 leading-relaxed">
                Trasformare ogni attività locale in un punto di riferimento per il territorio,
                abbattendo i confini tra esperienza digitale e fisica.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.15 }}
              className="glass gradient-border rounded-3xl p-8"
              data-testid="about-team"
            >
              <div className="flex items-center gap-3 text-purple-300 mb-3">
                <Users size={20} strokeWidth={1.7} />
                <span className="text-xs uppercase tracking-[0.25em]">Il team</span>
              </div>
              <p className="text-slate-200 leading-relaxed">
                Un Senior Marketing Manager e una Content &amp; Communication Specialist: visione
                strategica ed energia creativa, insieme, per ogni azienda.
              </p>
            </motion.div>

            <div className="grid grid-cols-2 gap-5 sm:col-span-2">
              {[
                { k: "+20", v: "Clienti soddisfatti" },
                { k: "100%", v: "Contenuti su misura per te" },
                { k: "5+", v: "Piattaforme social gestite" },
                { k: "1", v: "Referente dedicato" },
              ].map((s) => (
                <div
                  key={s.v}
                  className="glass rounded-2xl p-6"
                  data-testid={`about-stat-${s.v.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <div className="font-display text-3xl md:text-4xl text-white">{s.k}</div>
                  <div className="text-xs uppercase tracking-widest text-slate-400 mt-2">{s.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
